import { Component, inject, input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { CreateClientModalComponent } from '../create-client-modal/create-client-modal.component';
import { deleteClient } from '../../../../state';
import { MatDialog } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { WheelHistoryComponent } from '../wheel-history/wheel-history.component';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'wil-admin-tab-client-card',
  standalone: true,
  imports: [MatIcon, MatIconButton, MatTooltip, ClipboardModule, DatePipe],
  templateUrl: './admin-tab-client-card.component.html',
  styleUrl: './admin-tab-client-card.component.scss',
})
export class AdminTabClientCardComponent {
  private readonly dialog = inject(MatDialog);
  private readonly store = inject(Store);

  public readonly client = input.required<ParticipantOutputWithLinksDto>();

  public onEditClient(): void {
    this.dialog.open(CreateClientModalComponent, {
      width: '600px',
      maxWidth: '90vw',
      maxHeight: '90vh',
      disableClose: false,
      hasBackdrop: true,
      panelClass: 'create-client-modal-panel',
      data: {
        mode: 'edit',
        client: this.client(),
      },
    });
  }

  public onDeleteClient(): void {
    this.store.dispatch(deleteClient({ id: this.client().id }));
  }

  public onCopyLink(link: ResolvedWheelLink): void {
    // The ClipboardModule will handle the actual copying
    console.log('Link copied:', link.linkUrl);
  }

  public openHistory(): void {
    this.dialog.open(WheelHistoryComponent, {
      maxWidth: '90vw',
      maxHeight: '90vh',
      disableClose: false,
      hasBackdrop: true,
      panelClass: 'opan-history-modal-panel',
    });
  }
}
